import React from "react";
import "./HiringSection.css";
import thereInvite from "../assets/images/there-invite.png";
import useDevice from "../hooks/useDevice";

const ProjectTitle = () => <h1>Un projet auto-produit</h1>;
const CTABlock = ({ isDesktop }) => {
  return (
    <div className={`hiring__image-wrapper ${isDesktop ? "" : "flipped"}`}>
      <img src={thereInvite} alt="Invite" className="hiring__image" />
      <div className="hiring__cta-block">
        <button className="hiring__cta">Rejoins la vague</button>
        <p className="hiring__cta-sub">*Intro / CV / Portefolio / Contact</p>
      </div>
    </div>
  );
};

const HiringSection = () => {
  const { isDesktop } = useDevice();
  return (
    <section className="hiring">
      {isDesktop ? (
        <CTABlock isDesktop />
      ) : (
        <div className="hiring__cta-mobile">
          {!isDesktop && <ProjectTitle />}
          <CTABlock isDesktop={isDesktop} />
        </div>
      )}
      <div className="hiring__content">
        {isDesktop && <ProjectTitle />}
        <p>
          … mené avec rigueur, talent et respect. Équipe bénévole et defrayée.
        </p>
        <p>
          On cherche des coéquipiers animés par la narration, qui collaborent et
          échangent pour grandir ensemble. Si ça te parle, let’s talk!
        </p>
      </div>
    </section>
  );
};

export default HiringSection;
